/**
 * @generated SignedSource<<d3a787a5e5852d9ae21c60628f384559>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ComponentType = "CHECKIN" | "HABIT" | "LESSON" | "MESSAGE" | "WORKOUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CoachComponentTitle_component$data = {
  readonly title: string;
  readonly type: ComponentType;
  readonly " $fragmentSpreads": FragmentRefs<"ComponentIcon_component" | "SelectComponentIcons_component">;
  readonly " $fragmentType": "CoachComponentTitle_component";
};
export type CoachComponentTitle_component$key = {
  readonly " $data"?: CoachComponentTitle_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"CoachComponentTitle_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "draft"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CoachComponentTitle_component",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ComponentIcon_component"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectComponentIcons_component"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "draft",
          "variableName": "draft"
        }
      ],
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Component",
  "abstractKey": null
};

(node as any).hash = "560515263aabe7e15f7785a81a62bb6d";

export default node;
